var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"products",attrs:{"title":"Enheder"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createButtonClick},slot:"tools"}),_c('new-table-view',{attrs:{"columns":[
		{
			label: 'Navn',
			name: 'name'
		},
		{
			label: 'Type',
			name: ['_embedded', 'unit_type', 'name']
		},
		{
			label: 'Rumfang [m3]',
			name: ['_embedded', 'unit_type', 'volume']
		},
		{
			label: 'Længde [cm]',
			name: ['_embedded', 'unit_type', 'length']
		},
		{
			label: 'Bredde [cm]',
			name: ['_embedded', 'unit_type', 'width']
		},
		{
			label: 'Højde [cm]',
			name: ['_embedded', 'unit_type', 'height']
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		}
	],"items":_vm.items},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }